import * as yup from 'yup';

export const validationSchema = yup.object().shape({
	name: yup.string().min(4, 'Demaciado corto').required('Este campo es obligatorio'),
	lastname: yup.string().min(4, 'Demaciado corto').required('Este campo es obligatorio'),
	age: yup.number().typeError('Este campo es obligatorio'),
	dni: yup
		.number()
		.typeError('Sólo se permiten números')
		.required('Este campo es obligatorio'),
	address: yup.string().min(4, 'Demaciado corto').required('Este campo es obligatorio'),
	nametutor: yup.string().min(4, 'Demaciado corto').required('Este campo es obligatorio'),
	lastnametutor: yup
		.string()
		.min(4, 'Demaciado corto')
		.required('Este campo es obligatorio'),
	dnitutor: yup
		.number()
		.typeError('Sólo se permiten números')
		.required('Este campo es obligatorio'),
	addresstutor: yup
		.string()
		.min(4, 'Demaciado corto')
		.required('Este campo es obligatorio'),
	phone: yup
		.number()
		.typeError('Sólo se permiten números')
		.required('Este campo es obligatorio'),
	email: yup
		.string()
		.email('Debe ser un email válido')
		.required('Este campo es obligatorio'),
	parentesco: yup.string().required('Este campo es obligatorio'),
});
